import { animate, style, transition, trigger } from '@angular/animations';
import { ElementRef, Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'evsb-smooth-height',
  template: ` <div [@grow]="grow" (@grow.done)="sendAnimationFinished()"><ng-content></ng-content></div> `,
  styles: [
    `
      :host {
        display: block;
        overflow: hidden;
      }
    `,
  ],
  animations: [
    trigger('grow', [
      transition('void <=> *', []),
      transition('* <=> *', [style({ height: '{{startHeight}}px', opacity: 0 }), animate('.5s ease')], {
        params: { startHeight: 0 },
      }),
    ]),
  ],
})
export class SmoothHeightComponent implements OnChanges {
  grow: any;

  @Input()
  trigger: any;
  @Output() animationDone = new EventEmitter();

  startHeight: number;

  constructor(private element: ElementRef) {}

  ngOnChanges() {
    this.startHeight = this.element.nativeElement.clientHeight;
    this.grow = {
      value: this.trigger,
      params: { startHeight: this.startHeight },
    };
  }
  public sendAnimationFinished() {
    this.animationDone.emit();
  }
}
